module.exports = __webpack_public_path__ + "static/media/eliminated.2086e151.svg";